module.exports = __webpack_public_path__ + "media/entities/1129-3099c528.png";